
export default {
	name: 'pascalCase',
	handler: {
		update: function (element, valueAccessor, allBindingsAccessor, viewModel) {
			let value = ko.toJS(valueAccessor());
			let pascalCase;
			if (typeof value === 'string')
				pascalCase = value.replace('_', ' ').toLowerCase().replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });

			else if (typeof value === 'object')
			{
				let arr = [];
				for (let i = 0; i < value.length; i++)
					arr.push(value[i].replace('_', ' ').toLowerCase().replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); }));

				pascalCase = arr.join();
			}

			if (pascalCase)
				$(element).text(pascalCase);
			else
				$(element).text(valueAccessor());
		}
	}
};
